// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"BAnr0lvKhe2eWjU"};